export const mobileConfig = [
    {
        lowerBound: 0,
        uppperBound: 0.5,
        config: {
            width: 250,
            height: 390,
            scale: 1,
        },
    },
    {
        lowerBound: 0.5,
        uppperBound: 0.8,
        config: {
            width: 224,
            height: 350,
            scale: 0.9,
        },
    },
    {
        lowerBound: 0.8,
        uppperBound: 1.25,
        config: {
            width: 132,
            height: 211,
            scale: 0.53,
        },
    },
    {
        lowerBound: 1.25,
        uppperBound: 2.28,
        config: {
            width: 64,
            height: 99,
            scale: 0.25,
        },
    },
    {
        lowerBound: 1.25,
        config: {
            width: 39,
            height: 63,
            scale: 0.16,
        },
    },
];
export const desktopConfig = [
    {
        lowerBound: 0,
        uppperBound: 1,
        config: {
            width: 427,
            height: 270,
            scale: 1,
        },
    },
    {
        lowerBound: 1,
        uppperBound: 1.9,
        config: {
            width: 300,
            height: 188,
            scale: 0.7,
        },
    },
    {
        lowerBound: 1.9,
        uppperBound: 3.5,
        config: {
            width: 150,
            height: 94,
            scale: 0.35,
        },
    },
    {
        lowerBound: 3.5,
        uppperBound: 5,
        config: {
            width: 93,
            height: 58,
            scale: 0.21,
        },
    },
    {
        lowerBound: 4,
        config: {
            width: 75,
            height: 46,
            scale: 0.17,
        },
    },
];
//# sourceMappingURL=config.js.map